import axios from "axios";

const getAll = () => {
  return axios
    .get(`/customers`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const get = (id) => {
  return axios
    .get(`/customers/${id}`)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

const create = obj => {
  return axios.post('/customers', obj)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

const update = (id, obj) => {
  return axios.put(`/customers/${id}`, obj)
  .then(response => response)
  .catch(error => {
    throw error
  })
}

export {
  getAll,
  get,
  create,
  update,
}
